import { createAction } from 'redux-actions';
import * as types from './applicationTypes';

export const setGeneralError = createAction(types.SET_GENERAL_ERROR, message => message);
export const clearGeneralError = createAction(types.CLEAR_GENERAL_ERROR);
export const showNotification = createAction(types.SHOW_NOTIFICATION, (message, level) => ({ message, level }));
export const clearNotification = createAction(types.CLEAR_NOTIFICATION);
export const setLoading = createAction(types.SET_LOADING, key => key);
export const unsetLoading = createAction(types.UNSET_LOADING, key => key);
